export default class CartUpsells extends HTMLElement {
    upsellLimit = 3;
    upsellSection = 'same-cart-upsells';

    constructor() {
        super();
        
        debug('CartUpsells');
    }
    
    connectedCallback() {
        this.setupEventListeners();
    }
    
    disconnectedCallback() {}

    setupEventListeners() {
        document.addEventListener('ajaxProduct:added', (event) => {          
          this.updateUpsells(event.detail.product);          
        });    
    }
    
    updateUpsells(product) {              
        fetch(window.Shopify.routes.root + `recommendations/products?product_id=${product.product_id}&limit=${this.upsellLimit}&section_id=${this.upsellSection}&intent=complementary`)
          .then(response => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            
            if (text && html.innerHTML.trim().length) {
              this.innerHTML = html.innerHTML;
              
              setTimeout(() => {
                this.classList.add('appear-animation', 'appear-delay-3');
                this.initItems();
              }, 10);
            }
        });          
    }
    
    initItems() {
        debug('CartUpsells initUpsellItems');
        
        let items = this.querySelectorAll('.cart-upsell__item');
        if (items.length > 0) {
            items.forEach((item) => {
                item.querySelector('button').addEventListener('click', (event) => {
                    event.preventDefault();
                    
                    this.resetItems();
                    this.submitItem(item);
                });
                
                item.querySelector('select').addEventListener('change', (event) => {
                    event.preventDefault();
                    
                    this.resetItems();
                });
            });
        }
        
        AOS.init();
    }
    
    submitItem(item) {
        let select = item.querySelector('select');
        let variantId = select.value;
        
        if ( ! variantId) {
            debug('CartUpsells variant not found');
            item.classList.add('error');
            select.setAttribute('aria-invalid', true);
                                                            
            return;
        }
        
        this.addToCart(item, variantId);
    }
    
    resetItems() {
        let items = this.querySelectorAll('.cart-upsell__item');
        if (items.length > 0) {
            items.forEach((item) => {
                let select = item.querySelector('select');
                
                item.classList.remove('error');
                select.setAttribute('aria-invalid', false);
            });
        }
    }
    
    addToCart(item, variantId) {
        debug('CartUpsells addToCart', variantId);
    
        const fetchConfig = {
            method: 'POST',
            headers: {
                'Accept': 'application/javascript',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                'items': [{
                    'id': variantId,
                    'quantity': 1
                }]
            })
        };

        fetch(`${theme.routes.cartAdd}`, fetchConfig)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {                
                    return;
                }

                document.dispatchEvent(new CustomEvent('cart:build'));
                document.dispatchEvent(new CustomEvent('cart:upsellAdded'));
                
                item.remove();
            })
            .catch((error) => {
                debug(error);
            });
    }    
}